import React, {Component} from 'react';
import {Col, Form, FormGroup, ControlLabel, ButtonToolbar, Checkbox} from "react-bootstrap";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import {TopButtonCancel, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import {TopAlertInformacja, TopAlertUwaga} from "../../../../../componentsTopsa/alerty/TopAlerts";

export default class EprzystankiForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            przystanekOd: null,
            przystankiDo: [],
            error: false
        };
        this.onChangePrzystanekOd = this.onChangePrzystanekOd.bind(this)
        this.onChangePrzystankiDo = this.onChangePrzystankiDo.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.renderValuePrzystanekDo = this.renderValuePrzystanekDo.bind(this)
        this.onClickZmienRezerwacje = this.onClickZmienRezerwacje.bind(this)
    }

    componentDidMount() {
        if (Boolean(this.props.eprzystanek)) {
            this.setState({
                przystanekOd: this.props.eprzystanek.przystanekOd,
                przystankiDo: this.props.eprzystanek.przystanki
            })
        }
    }

    componentWillReceiveProps(nextprops) {
    }

    onChangePrzystanekOd(e) {
        this.setState({przystanekOd: e})
    }

    onChangePrzystankiDo(e) {
        this.setState({przystankiDo: e})
    }

    onClickZapisz() {
        this.setState({error: false})
        if (Boolean(this.state.przystanekOd)) {
            this.props.handleZapisz(this.state.przystanekOd, this.state.przystankiDo, Boolean(this.props.eprzystanek))
        }
        else {
            this.setState({error: true})
        }
    }

    onClickZmienRezerwacje(obj) {
        let arr = this.state.przystankiDo
        arr[arr.findIndex(p => p.idPr === obj.idPr)].rezerwacja = !(this.state.przystankiDo[arr.findIndex(p => p.idPr === obj.idPr)].rezerwacja)
        this.setState({przystankiDo: arr})
    }

    renderPrzystanekOd(option) {
        return <span><span className={'label label-ebus-default'}>{option.nazMi}</span> {option.nazPr}</span>
    }

    renderValuePrzystanekDo(option) {
        return <span style={{display: 'inline-block', paddingRight: '10px'}}>
                <span>{option.nazMi}</span>
                <span style={{margin: '0 5px'}}>{option.nazPr}</span>
                <Checkbox checked={Boolean(option.rezerwacja)} title={'Czy jest możliwa rezerwacja?'} inline={true}
                          style={{position: 'absolute', marginTop: '-8px'}} onClick={() => {
                    this.onClickZmienRezerwacje(option)
                }}></Checkbox>
            </span>
    }

    renderOptionPrzystanekDo(option) {
        return <span>
                <span className={'label label-ebus-default'}>{option.nazMi}</span>
                <span style={{margin: '0 5px'}}>{option.nazPr}</span>
            </span>
    }

    render() {
        return (
            <div style={{marginTop: '15px'}}>
                <fieldset>
                    <div className={'fieldset-label'}>{Boolean(this.props.przystanek) ? 'Edycja eprzystanków' : 'Nowe eprzystanki'} na trasie {Boolean(this.props.trasa) ? this.props.trasa.nazTr : ''}</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12} lg={3}>
                                <ControlLabel>Przystanek od</ControlLabel>
                                <TopSelect onChange={this.onChangePrzystanekOd} value={this.state.przystanekOd} options={this.props.przystanki}
                                           labelKey={'info'} valueKey={'idPr'} valueRenderer={this.renderPrzystanekOd}
                                           optionRenderer={this.renderPrzystanekOd}
                                           placeholder={'Szukaj po miejscowości, przystanku...'}
                                />
                            </Col>
                            <Col xs={12} lg={7}>
                                <ControlLabel>Przystanki do <TopAlertInformacja inline={true} text={' '}/></ControlLabel>
                                <TopSelect onChange={this.onChangePrzystankiDo} value={this.state.przystankiDo} options={this.props.przystanki} multi
                                           labelKey={'info'} valueKey={'idPr'} valueRenderer={this.renderValuePrzystanekDo}
                                           optionRenderer={this.renderOptionPrzystanekDo}
                                           placeholder={'Szukaj po miejscowości, przystanku...'}
                                />
                            </Col>
                            <Col xs={12} lg={2}>
                                <div className={'add-label-margin'}></div>
                                <ButtonToolbar>
                                    <TopButtonSave onClick={this.onClickZapisz}/>
                                    <TopButtonCancel onClick={() => {
                                        this.props.handleClickAnuluj()
                                    }}/>
                                </ButtonToolbar>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12}>
                                <TopAlertInformacja text={'Aby ozaczyć przystanek objęty możliwością rezerwacji, zaznacz checkbox'}/>
                                <TopIf isTrue={Boolean(this.props.eprzystanek)}>
                                    <TopAlertInformacja text={'Aby usunąć połączenia, należy zapisać pustą listę przystanków do'}/>
                                </TopIf>
                            </Col>
                            <TopIf isTrue={this.state.error}>
                                <Col xs={12} lg={12}>
                                    <TopAlertUwaga text={'Należy wybrać przystanek od i co najmniej jeden przystanek do'}/>
                                </Col>
                            </TopIf>
                        </FormGroup>
                    </Form>
                </fieldset>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/ePrzystanki/components/EprzystankiForm.js